<div class="breed-form">
    <mat-checkbox [(ngModel)]="model.cold">Kallblodiga hästar</mat-checkbox>
    <mat-checkbox [(ngModel)]="model.warm">Varmblodiga hästar</mat-checkbox>
</div>
